import React from 'react';
import { CourseRequest, CoursesMode } from '../../../api/course';
import { NotFound } from '../../../components/NotFound/NotFound';
import { Loader } from '../../../components/Loader';
import { Pagination } from '../../../horizon-components/Pagination';
import { useCourses } from '../../../entities/Courses';
import { CourseCard } from '../../../widgets/CourseCard';
import { useTranslation } from 'react-i18next';

interface CoursesGetStartedProps {
  filters: Omit<CourseRequest, 'page'>;
}

export const CoursesGetStarted: React.FC<CoursesGetStartedProps> = ({ filters }) => {
  const { t } = useTranslation(['translation']);
  const { data, isLoading, total, page, setPage } = useCourses(filters);

  return (
    <div className="flex flex-col gap-4 md:gap-[20px]">
      <h3 className="text-2xl font-bold text-secondary-grey-800">
        {t('course.coursesToGetYouStarted')}
      </h3>
      {isLoading ? (
        <Loader />
      ) : data?.results.length ? (
        <div className="grid gap-x-6 gap-y-5 md:grid-cols-3 lg:grid-cols-4">
          {data?.results?.map((course) => (
            <CourseCard course={course} key={course.id} />
          ))}
        </div>
      ) : (
        <NotFound />
      )}
      {!!total && (
        <div className={'flex w-full items-center justify-center'}>
          <Pagination
            totalPages={total}
            currentPage={page}
            showPrevNext={true}
            onPageChange={setPage}
          />
        </div>
      )}
    </div>
  );
};
